// src/components/content/RiskRegister.js
import {
    Box,
    Button,
    Card,
    CardContent, IconButton, MenuItem, Table,
    TableBody, TableContainer, TextField, Tooltip
} from '@mui/material';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { ConfirmDialog } from 'src/components/custom-dialog';
import Iconify from 'src/components/iconify';
import { LoadingScreen } from 'src/components/loading-screen';
import Scrollbar from 'src/components/scrollbar';
import {
    emptyRows,
    getComparator,
    TableEmptyRows,
    TableHeadCustom,
    TableNoData,
    TablePaginationCustom,
    TableSelectedAction,
    useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import { deleteRequest, getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import Header from '../header';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { applyFilter } from 'src/layouts/_common/searchbar/utils';
import { DatePicker } from '@mui/x-date-pickers';
import UserTableRows from './generate-payroll-table-row';
import GenratePayrollSettingsModal from './genrate-payroll-setttings-modal';
import { useNavigate } from 'react-router';

const GeneratePayroll = () => {
    const popover = usePopover();
    const table = useTable();
    const add = useBoolean();
    const confirm = useBoolean();
    const create = useBoolean();
const navigate = useNavigate();
    const [ loading, setLoading ] = useState(false);
    const [ selectedItem, setSelectedItem ] = useState({});
    const [ users, setUsers ] = useState([]);
    
    const TABLE_HEAD = [
        { id: 'id', label: 'Sr.no' },
        { id: 'payrollNumber', label: 'Payroll Number' },
        { id: 'subContractor', label: 'SubContractor' },
        { id: 'weekendEnding', label: 'Weekend Ending' },
        { id: 'address', label: 'Address' },
        { id: 'grossAmount', label: 'Total Gross Amount' },
        { id: 'weeklyWage', label: 'Total Weekly Paid Wage' },
        { id: 'paymentStatus', label: 'Payment Status' },
        { id: 'status', label: 'Status' },
        { id: 'action', label: 'Action' },
    ];

    const [ tableData, setTableData ] = useState();
    const [ filters, setFilters ] = useState({
        name: '',
        date: null,
    });
    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [ key ]: value }));
    };
    const clearFilters = () => {
        setFilters({
            name: '',
            date: null,
        });
    };
    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });
    const filteredData = dataFiltered?.filter((row) => {
        let matchName = true;
        let matchDate = true;
        if (filters.name) {
            matchName = Object.values(row)
                .some((value) =>
                    value && value.toString().toLowerCase().includes(filters.name.toLowerCase())
                );
        }
        if (filters.date) {
            const rowDate = new Date(row.weekendEnding).setHours(0, 0, 0, 0);
            const filterDate = new Date(filters.date).setHours(0, 0, 0, 0);
            matchDate = rowDate === filterDate;
        }
        return matchName && matchDate;
    });

    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
    const notFound = (!dataFiltered?.length && canReset) || !dataFiltered?.length;

    useEffect(() => {
        getUserList();
        getGeneratePayrollList();
    }, []);

    const getGeneratePayrollList = async () => {
        setLoading(true);
        const response = await getRequest(`${endpoints.accounting.payroll.generate_payroll.get_employee_list}`);
        setLoading(false);
         console.log("🚀 ~ getGeneratePayrollList ~ response:", response)
         if (response) {
            setTableData(response);
            
        }
    };
      const getUserList = async () => {
        const res = await getRequest(endpoints.accounting.payroll.generate_payroll.get_user_list);
        if (res) setUsers(res);
      };
    
    const deleteCallBack = () => {
        confirm.onFalse();
        getGeneratePayrollList();
    };
    const handleCloseForm = () => {
        create.onFalse();
        setSelectedItem({});
        table.onSelectAllRows(false, []); // Clear selected rows when closing the form
    };

  const handleDeleteRow = async (id) => {
    await deleteRequest(`${endpoints.accounting.payroll.generate_payroll.delete}/${id}`, deleteCallBack);
    
  };
    const handleEditRow = (item) => {
        setSelectedItem(item); // Set the selected item for editing
        add.onTrue();
    };

    return (
        <>
            <Card sx={ { height: '100%', marginTop: '10px', overflow: 'hidden' } }>
                <CardContent>
                    { loading ? (
                        <Box height={ 700 }>
                            <LoadingScreen />
                        </Box>
                    ) : (
                        <>
                            <Header name="Generate Payroll" />
                            <Box
                                sx={ {
                                    display: 'flex',
                                    paddingBottom: '20px',
                                    justifyContent: 'space-between',
                                    gap: '12px',
                                    marginTop: '10px',
                                } }
                            >
                                <Box>
                                </Box>
                                <Box
                                    sx={ {
                                        display: 'flex',
                                        paddingBottom: '20px',
                                        justifyContent: 'flex-end',
                                        gap: '12px',
                                    } }
                                >
                                    <Button
                                        onClick={ popover.onOpen }
                                        className="dark-button"
                                        variant="contained"
                                        startIcon={ <Iconify icon="material-symbols:filter-alt" /> }
                                    >Filters
                                    </Button>
                                    <Button
                                      onClick={ () => {
                                        setSelectedItem({});
                                        add.onTrue();
                                    } }
                                        className="dark-button"
                                        variant="contained"
                                        startIcon={ <Iconify icon="material-symbols:settings" /> }
                                    >
                                    </Button>
                                    <Button
                                        onClick={ () => navigate(`/accounts-management/payroll/genrate-payroll-create-page`, {
                                            // state: {
                                            //     rowData: row,
                                            // }
                                          }) }
                                        className="dark-button"
                                        variant="contained"
                                        startIcon={ <Iconify icon="mingcute:add-line" /> }
                                    >
                                        Create
                                    </Button>
                                </Box>
                            </Box>
                            <CustomPopover
                                open={ popover.open }
                                onClose={ popover.onClose }
                                arrow="bottom-bottom"
                                sx={ { width: 1000, padding: 1, background: 'white !important' } }
                            >
                                <MenuItem
                                    disableRipple
                                    sx={ {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 2,
                                        color: '#000',
                                        background: 'white !important',
                                        '&:hover': { backgroundColor: 'white !important' },
                                    } }
                                >
                                    <Iconify
                                        icon="mdi:close"
                                        onClick={ popover.onClose }
                                        sx={ {
                                            width: 20,
                                            height: 20,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            borderRadius: '50%',
                                            backgroundColor: '#F4F6F8',
                                            color: '#637381',
                                        } }
                                    />
                                    <TextField
                                        label="Search..."
                                        size="medium"
                                        value={ filters.name }
                                        onChange={ (e) => handleFilterChange('name', e.target.value) }
                                        placeholder="Search by name..."
                                        variant="outlined"
                                        sx={ {
                                            flex: 1,
                                            '& .MuiOutlinedInput-root': {
                                                '&:hover fieldset': {
                                                    borderColor: '#e0e0e0 !important',
                                                },
                                            },
                                        } }
                                    />
                                    <DatePicker
                                        label="Filter by Date"
                                        value={ filters.date || null }
                                        onChange={ (date) => handleFilterChange('date', date) }
                                        renderInput={ (params) => (
                                            <TextField
                                                { ...params }
                                                size="small"
                                                variant="outlined"
                                                sx={ {
                                                    flex: 1,
                                                    width: '100%',  // Ensure it takes full width
                                                    '& .MuiOutlinedInput-root': {
                                                        '&:hover fieldset': {
                                                            borderColor: '#e0e0e0 !important',
                                                        },
                                                    },
                                                } }
                                            />
                                        ) }
                                    />
                                    <IconButton onClick={ clearFilters }>
                                        <Iconify icon="material-symbols:device-reset" sx={ { fontSize: '30px' } } />
                                    </IconButton>
                                </MenuItem>
                            </CustomPopover>
                            <Card
                                sx={ {
                                    mt: 3,
                                    boxShadow: '0px 0px 30px 0px #64748B1A',
                                } }
                            >
                                <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                                    <TableSelectedAction
                                        dense={ table.dense }
                                        numSelected={ table?.selected?.length }
                                        rowCount={ tableData?.length }
                                        onSelectAllRows={ (checked) =>
                                            table.onSelectAllRows(
                                                checked,
                                                tableData?.map((row) => row.id)
                                            )
                                        }
                                        action={
                                            <Tooltip title="Delete">
                                                <IconButton color="primary" onClick={ confirm.onTrue }>
                                                    <Iconify icon="solar:trash-bin-trash-bold" />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    />
                                    <Scrollbar>
                                        <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                            <TableHeadCustom
                                                order={ table.order }
                                                orderBy={ table.orderBy }
                                                headLabel={ TABLE_HEAD }
                                                rowCount={ tableData?.length }
                                                numSelected={ table?.selected?.length }
                                                onSort={ table.onSort }
                                                onSelectAllRows={ (checked) =>
                                                    table.onSelectAllRows(
                                                        checked,
                                                        tableData.map((row) => row.id)
                                                    )
                                                }
                                            />
                                            <TableBody>
                                                { filteredData
                                                    ?.slice(
                                                        table.page * table.rowsPerPage,
                                                        table.page * table.rowsPerPage + table.rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <UserTableRows
                                                            key={ row.id }
                                                            row={ row }
                                                            selected={ table.selected.includes(row.id) }
                                                            onSelectRow={ () => table.onSelectRow(row.id) }
                                                            onDeleteRow={ () => handleDeleteRow(row.id) }
                                                            onEditRow={ () => handleEditRow(row) }
                                                            serialNumber={ table.page * table.rowsPerPage + index + 1 }
                                                            users={users}
                                                            reload={ () => getGeneratePayrollList() }
                                                        />
                                                    )) }
                                                <TableEmptyRows
                                                    height={ denseHeight }
                                                    emptyRows={ emptyRows(table.page, table.rowsPerPage, tableData?.length) }
                                                />
                                                <TableNoData notFound={ notFound } />
                                            </TableBody>
                                        </Table>
                                    </Scrollbar>
                                </TableContainer>
                                <TablePaginationCustom
                                    count={ dataFiltered?.length }
                                    page={ table.page }
                                    rowsPerPage={ table.rowsPerPage }
                                    onPageChange={ table.onChangePage }
                                    onRowsPerPageChange={ table.onChangeRowsPerPage }
                                    dense={ table.dense }
                                    onChangeDense={ table.onChangeDense }
                                />
                            </Card>
                        </>
                    ) }
                </CardContent>
            </Card>
            <GenratePayrollSettingsModal
                currentItem={ selectedItem }
                open={ add.value }
                onClose={ add.onFalse }
                // reload={ getCustomersList }
                closeform={ () => handleCloseForm() }
            />
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you want to delete selected items?"
                action={
                    <Button
                        variant="contained"
                        className="dark-button"
                        onClick={ () => {
                            //handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
};
export default GeneratePayroll;